module.exports = __webpack_public_path__ + "static/img/20012 (7).a7fb61d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20012 (7).jpg
// module id = pGGm
// module chunks = 14